import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/api';

export default function SetupPassword() {
  const { t } = useTranslation('auth');
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get('token') || '', [params]);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setMsg(t('passwordsMismatch'));
      return;
    }
    setLoading(true);
    setMsg('');
    try {
      const { data } = await authService.confirmPasswordReset({ token, new_password: password });
      setMsg(data.message || t('setupSuccess'));
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setMsg(t('setupError'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 bg-slate-950">
        <div className="text-center space-y-3 max-w-md text-white">
          <p>{t('setupInvalid')}</p>
          <p className="text-sm text-slate-300">
            {t('setupAskAdmin')}
          </p>
          <Link to="/login" className="text-primary-300 hover:underline">
            {t('goToLogin')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.97] shadow-strong p-8 space-y-4">
        <h1 className="text-xl font-bold text-gray-900">{t('setupTitle')}</h1>
        <p className="text-sm text-gray-600">
          {t('setupLead')}
        </p>
        <form onSubmit={submit} className="space-y-3">
          <input
            className="form-input w-full"
            type="password"
            required
            minLength={8}
            placeholder={t('setupPlaceholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            className="form-input w-full"
            type="password"
            required
            minLength={8}
            placeholder={t('confirmPassword')}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          <button type="submit" disabled={loading} className="btn btn-primary w-full">
            {loading ? t('common:saving') : t('setupAction')}
          </button>
        </form>
        {msg && (
          <p className={`text-sm ${msg.toLowerCase().includes('sucesso') || msg.toLowerCase().includes('success') ? 'text-green-700' : 'text-gray-700'}`}>
            {msg}
          </p>
        )}
      </div>
    </div>
  );
}
